import { Validators } from "@angular/forms";
import { AdministrationEndpoints } from "@app/shared/data-access/src/lib/administration/types/administration-endpoints";
import {
  HardFormFieldTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
} from "@app/shared/ui-lib/src/lib";
import { IHardTable } from "@app/shared/ui-lib/src/lib/hard-table/models/base-config";
import { HardTableColumnTypeEnum } from "@app/shared/ui-lib/src/lib/hard-table/models/table-column";
import { IBaseConfig, IFormFieldFilter } from "@models/form/base-config";
import { IBpUser } from "@models/user-management/user";
import { BpUserToggleComponent } from "@modules/admin/modules/dictionary-modules/bp-users/bp-user-toggle/bp-user-toggle.component";

export class BpUserConfig implements IBaseConfig {
  version = 1;
  dicType = AdministrationEndpoints.BpUser;
  title = "dicitionary.bpUsers";
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      title: "dicTable.fullName",
      name: "fullName",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },

    {
      title: "dicTable.email",
      name: "email",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required, Validators.email],
      },
    },

    {
      title: "dicTable.businessPartner",
      name: "businessPartner",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + AdministrationEndpoints.BusinessPartner,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
  ];

  saveCallback(data: IBpUser) {
    const businessPartnerId = data?.businessPartner?.id;
    delete data?.businessPartner;

    return { ...data, businessPartnerId };
  }

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: IHardTable<IBpUser[]> = {
    showDefaultActions: true,
    tableColumns: "44px repeat(5, auto) 120px",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.fullName",
        name: "fullName",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.email",
        name: "email",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.userType",
        name: "userTypeTemplate",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.jobTitle",
        name: "jobTitle",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        title: "dicTable.isActive",
        name: "isActive",
        type: HardTableColumnTypeEnum.Component,
        component: BpUserToggleComponent,
      },
    ],
    dataCallback: this.dataCallback,
  };

  dataCallback(data: IBpUser[]) {
    return data.map((item) => ({
      ...item,
      userTypeTemplate: item?.isActive
        ? "dicTable.userActive"
        : "dicTable.userInactive",
    }));
  }
}
